import React from 'react'
import Header  from '../../components/Header'
import {imageUrl } from '../../utils/utils'
//vip 与京东广告页面
export default class articleVipJd extends React.Component{
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // this.requestList()
    // let _this = this
    // document.addEventListener('touchstart', function () {
    //     let audio = audio = _this.refs.audio;
    //     if (audio) {
    //       audio.play();
    //     }
    // });
  }

  requestList = () => {
    // cateList({
    //   cate_id: this.state.cateId
    // }).then((res)=>{
    //   this.setState({
    //     cateItem: res,
    //     stories: res.story,
    //     currentMusic: this.decryptFilename(res.story[0])
    //   })

    //   let audio = this.refs.audio;
    //   audio.autoplay = true
    // })
  }

  render() {
    return (
      <div>
        <img style={{width: '100%'}} src={imageUrl('/201812/3edba6fd3d9acccfae7956d85ab9b49d.jpg')} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/article/vipjd.js